import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SeasonPassService } from 'src/app/services/season-pass.service';
import { PanelTitleService } from 'src/app/services/panel-title.service';
import { getOrderStatusBadgeClass, getOrderStatusIcon } from '../orders-list/orders-list.component';
import { seasonPassSeatLabel } from 'src/app/helpers/season-pass-seat';

/**
 * Detalle de un pedido de abono (SeasonPassRenewal): qué se cobró, a quién,
 * por cuánto y con qué ticket. Es solo lectura — un cobro no se edita.
 */
@Component({
  selector: 'app-sports-passes-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class SeasonPassOrderDetailComponent implements OnInit, OnDestroy {

  business: any;
  order: any = null;
  loaded: boolean = false;
  loadError: boolean = false;

  private sub: Subscription | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private seasonPassService: SeasonPassService,
    private panelTitleService: PanelTitleService,
  ) { }

  ngOnInit(): void {
    this.business = JSON.parse(localStorage.getItem('business') || '{}');

    this.sub = this.route.params.subscribe(params => {
      const id = +params['id'];
      if (id) this.loadOrder(id);
    });
  }

  ngOnDestroy(): void {
    this.panelTitleService.setSubtitle(null);
    if (this.sub) this.sub.unsubscribe();
  }

  loadOrder(id: number) {
    this.loaded = false;
    this.loadError = false;

    this.seasonPassService.getRenewalById(this.business?.id, id).subscribe({
      next: (res) => {
        this.order = res.data;
        this.panelTitleService.setSubtitle(this.order?.num_ticket ? `Ticket ${this.order.num_ticket}` : `Pedido #${this.order?.id}`);
        this.loaded = true;
      },
      error: () => {
        this.loadError = true;
        this.loaded = true;
      }
    });
  }

  get statusBadgeClass(): string {
    return getOrderStatusBadgeClass(this.order?.status?.short_name);
  }

  get statusIcon(): string {
    return getOrderStatusIcon(this.order?.status?.short_name);
  }

  get isPaid(): boolean {
    return this.order?.status?.short_name === 'paid';
  }

  /**
   * El canal lo fija quién originó el cobro: si hay un admin en `created_by`
   * fue una venta en taquilla/TPV, si no, la pasarela online del abonado.
   */
  get channelLabel(): string {
    return this.order?.creator ? 'TPV / taquilla' : 'Pago online';
  }

  get channelIcon(): string {
    return this.order?.creator ? 'fa-cash-register' : 'fa-globe';
  }

  /** Lo que se cobró de más sobre el precio del producto (gastos de gestión). */
  get feeAmount(): number {
    return +(this.order?.total_fee || 0);
  }

  get subtotal(): number {
    return +(this.order?.price || 0) * (+this.order?.quantity || 1);
  }

  get seatDisplay(): string | null {
    return seasonPassSeatLabel(this.order?.season_pass);
  }

  goToPass() {
    const passId = this.order?.season_pass?.id;
    if (passId) this.router.navigate(['/panel-control/sports-passes/passes/edit', passId]);
  }

  goBack() {
    this.router.navigate(['/panel-control/sports-passes/orders']);
  }
}
